
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-gold shadow-2xl">
      <div className="container mx-auto px-4 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-gray-700">
              Web sitemizde size en iyi deneyimi sunabilmek için çerezleri kullanıyoruz. Detaylı bilgi için{' '}
              <Link to="/cerez-politikasi" className="text-gold hover:text-gold-dark font-semibold underline">
                Çerez Politikası
              </Link>
              {' '}sayfamızı ziyaret edebilirsiniz.
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleReject}
              className="px-6 py-2 border-2 border-navy text-navy rounded-full text-sm font-semibold hover:bg-navy hover:text-white transition-all duration-300 whitespace-nowrap"
            >
              Reddet
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 bg-gold hover:bg-gold-dark text-navy rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap"
            >
              Kabul Et
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
